import React from 'react'


import DelImg from '../../images/delete.png'
import Delete from "../../images/delete-icon.png";
import './Model.css'
const ModelTracer = ({closeModelTracer}) => {
  return (
    <div className='model-main '>
      <div className="model tracer-model">

        <div className="pop-head">
          <h5>Tracer NanoRX/ Top </h5>
         <img src={DelImg} onClick={()=> closeModelTracer(false)} alt="" />
        </div>
        <div className="pop-body">
        <div className="tracer-pop-details">
          <ul className="tracer-list d-flex">
            <li className="tracer-list-item">
              <p><b>1:</b> Lorem Ipsum is simply dummy text</p>
              <p><b>2:</b> Lorem Ipsum is simply dummy text</p>
              <p><b>3:</b> Lorem Ipsum is simply dummy text</p>
            </li>
            <li className="tracer-list-item">
             <div className="tracer-btn">
               <a href="#">EDIT</a>
             </div>
             <div className="tracer-btn">
               <a href="#">PERFORMED</a>
             </div>
            </li>
          </ul>
          <div className="tracer-table">
                    <table className="table table-bordered2">
                      <thead>
                        <tr>
                          <th >Date</th>
                          <th>Work</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                          <td >04-6-2022</td>
                          <td>Tracer NanoRX/ Top </td>
                          <td>PanalNanoRxProduction Task collection</td>
                        </tr>
                      <tr>
                          <td >04-6-2022</td>
                          <td>Tracer NanoRX/ Top </td>
                          <td>PanalNanoRxProduction Task collection</td>
                        </tr>                                                             
                        <tr>
                          <td >04-6-2022</td>
                          <td>Tracer NanoRX/ Top </td>
                          <td>PanalNanoRxProduction Task collection</td>
                        </tr>
                        <tr>
                          <td >04-6-2022</td>
                          <td>Tracer NanoRX/ Top </td>
                          <td>PanalNanoRxProduction Task collection</td>
                        </tr>
                        <tr>
                          <td >04-6-2022</td>
                          <td>Tracer NanoRX/ Top </td>
                          <td>PanalNanoRxProduction Task collection</td>
                        </tr>
                      </tbody>
                    </table>
          </div>
        </div>
      
        </div>

      </div>
    </div>

  )
}

export default ModelTracer;